module.exports = __webpack_public_path__ + "img/gouwuchekong.31f16e5d.svg";